export default __webpack_public_path__ + "static/media/img2.e71a9793.jpeg";